import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MagicLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    const doLogin = async () => {
      try {
        const res = await axios.get(`${API}/auth/magic-login`, {
          params: { token },
          withCredentials: true
        });
        const { _sessionToken, ...userData } = res.data;
        if (_sessionToken) {
          localStorage.setItem('sb_session', _sessionToken);
          axios.defaults.headers.common['Authorization'] = `Bearer ${_sessionToken}`;
        }
        await login(userData);
        navigate(userData.hasCompletedInitialAssessment ? '/dashboard' : '/onboarding', { replace: true });
      } catch (err) {
        const msg = err.response?.data?.detail || 'Link inválido ou expirado.';
        setError(msg);
      }
    };

    doLogin();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-purple-50 to-white flex items-center justify-center p-4">
        <div className="text-center max-w-sm">
          <div className="text-5xl mb-4">🔗</div>
          <h1 className="text-xl font-bold text-gray-900 mb-2">Link inválido</h1>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
          >
            Ir para o login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 to-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-purple-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Verificando acesso...</p>
      </div>
    </div>
  );
};

export default MagicLogin;
